export const createBaseFocusTrapOptions = () => {
  let returnFocusElement = null;

  return {
    // allow outside clicks since we have a backdrop element protecting the background elements,
    // otherwise it will lead to problems with toasts / messages above the dialog, password managers etc.
    allowOutsideClick: true,
    returnFocusOnDeactivate: true,
    // must be handled by component itself
    escapeDeactivates: false,
    onActivate: () => {
      // some stzh components recreate internal input element when rerendered
      // to make sure we don't loose reference, we safe reference to the stzh host element
      returnFocusElement = document.activeElement?.closest("stzh-dropdown, stzh-input");
    },
    setReturnFocus: (node) => {
      return returnFocusElement || node;
    }
  };
};
